import React, { useEffect, useMemo } from "react";
import { MeetingContext } from "@/pages/Meeting";
import Row from "antd/lib/grid/row";
import Col from "antd/es/grid/col";
import style from "./style.module.scss";
import VideoCard from "../VideoCard";

const DualLayout: React.FunctionComponent = () => {
  const { displayParticipants: participants, service } = React.useContext(MeetingContext);

  const localParticipant = participants.find((d) => d.local);

  const remoteParticipant = participants.find((d) => d.share) ||
    participants.find((d) => d.active) ||
    participants.find((d) => d.pinned && !d.local) ||
    participants[1] ||
    participants[0];

  const participantIds = useMemo(
    () => participants.map((peer) => peer.peerId).join(","),
    [participants]
  );

  useEffect(() => {
    if (!window.roomClient) {
      return;
    }

    const visiblePeerId =
      remoteParticipant && !remoteParticipant.local && !remoteParticipant.share
        ? remoteParticipant.peerId
        : "";

    const syncVisibleParticipants = async () => {
      for (const peer of participants) {
        if (!peer || peer.local || peer.share) {
          continue;
        }

        const visible = peer.peerId === visiblePeerId;
        if (peer.bInActivePage !== visible) {
          await service.setParticipantInActivePage(peer.peerId, visible);
        }
      }
    };

    syncVisibleParticipants();
  }, [participantIds, remoteParticipant?.peerId, service]);


  return <div className={style.container}>
    <Row gutter={8} justify="center">
      <Col flex={`0 0 50%`}>
        <VideoCard participant={localParticipant}></VideoCard>
      </Col>
      <Col flex={`0 0 50%`}>
        <VideoCard participant={remoteParticipant}></VideoCard>
      </Col>
    </Row>
  </div>;
};

export default DualLayout;
